<template>
    <div class="container">
        <h1>业务介绍</h1>
        <p>业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍业务介绍</p>
        <button style="margin-bottom: 15px;" class="btn btn_primary" @click="backToPay">返回</button>
    </div>
</template>

<script>
export default {
    name: 'BusinessIntr',
    data() {
        return {
        }
    },
    methods: {
        backToPay() {
            this.$router.push('/pay')
        },
    },
    mounted() {
    },
    created() {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "index";
</style>


// WEBPACK FOOTER //
// src/components/businessIntr.vue